<template>
    <div class="space-y-1">
        <AcessoRapido class="hidden lg:block" />
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-4">
            <div v-for="canal in canais" :key="canal.id" class="  rounded">
                <template v-if="canal.arquivos && canal.arquivos.length > 0">
                    <a v-if="canal.link" :href="canal.link" target="_blank" rel="noopener noreferrer">
                        <img :src="canal.arquivos[0].url" :alt="canal.nome"
                            class="w-full h-54 object-cover   shadow  rounded-lg"
                            @error="handleImageError" />
                    </a>
                    <img v-else :src="canal.arquivos[0].url" :alt="canal.nome"
                        class="w-full h-54 object-cover rounded-lg shadow"
                        @error="handleImageError" />
                </template>
            </div>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-1 gap-4 pt-4 pb-4">
            <div v-for="item in canais_list" :key="item.id" class="  rounded">
                <template v-if="item.arquivos && item.arquivos.length > 0">
                    <a v-if="item.link" :href="item.link" target="_blank" rel="noopener noreferrer">
                        <img :src="item.arquivos[0].url" :alt="item.nome"
                            class="w-full h-54 object-cover   shadow  rounded-lg"
                            @error="handleImageError" />
                    </a>
                    <img v-else :src="item.arquivos[0].url" :alt="item.nome"
                        class="w-full h-54 object-cover rounded-lg shadow"
                        @error="handleImageError" />
                </template>
            </div>
        </div>
        <div class="bg-white rounded-lg border border-gray-200 shadow-sm px-4 py-3 flex items-center gap-4">
            <div class="relative">
                <img src="../../Assets/Logo PMP AZUL V.png" alt="Logo da Prefeitura de Parnaíba"
                    class="w-14 h-14 rounded-full object-cover border-2 border-gray-400  " style="padding: 1px;" />
                <div
                    class="absolute inset-0 rounded-full bg-gradient-to-br from-pink-100 to-transparent opacity-30 pointer-events-none">
                </div>
            </div>
            <div class="flex-1 min-w-0">
                <p class="font-bold text-gray-700 text-base">Prefeitura de Parnaíba</p>
                <p class="text-xs text-gray-600">@prefeituradeparnaiba_</p>
                <div class="flex justify-start gap-6 mt-2 text-xs font-medium text-gray-800">
                    <div>
                        <span class="block font-bold">692</span>
                        <span class="text-xs text-gray-500">posts</span>
                    </div>
                    <div>
                        <span class="block font-bold">41,7 mil</span>
                        <span class="text-xs text-gray-500">seguidores</span>
                    </div>
                    <div>
                        <span class="block font-bold">25</span>
                        <span class="text-xs text-gray-500">seguindo</span>
                    </div>
                </div>
            </div>
            <a href="https://www.instagram.com/prefeituradeparnaiba_/" target="_blank" rel="noopener noreferrer"
                class="btn btn-sm font-semibold rounded-md px-4 py-2 "
                style="border: #2b96f6; border-radius: nano; background-color: #2b96f6; color: #fff;">
                Seguir
            </a>
        </div>

    </div>
</template>
<script setup>
import { ref, computed } from 'vue';
import { usePage, router } from '@inertiajs/vue3';
const { canais } = usePage().props;
const { canais_list } = usePage().props;
import AcessoRapido from '@/Components/AcessoRapido.vue';
const props = defineProps({
    acesso_rapido: {
        type: Array,
        required: true,
    },
})

const handleImageError = (e) => {
    if (e.target.src !== '/images/placeholder.svg') {
        e.target.src = '/images/placeholder.svg'
    }
}

const irParaVersaoAnterior = () => {
    window.location.href = 'https://parnaiba.pi.gov.br';
};
</script>
